import { useState } from 'react';

import {
  PlayerDrawer,
  Props as PlayerDrawerProps,
} from 'components/player/PlayerDrawer';
import { CardResultsProps } from 'searchCards/AdvancedCardSearch/types';
import { Pagination } from 'searchCards/Pagination';

import { CommonCardsGrid } from '../CommonCardsGrid';

export const PaginatedCommonCardsGrid = (props: CardResultsProps) => {
  const [cardOpened, setCardOpened] =
    useState<PlayerDrawerProps['cardOpened']>(null);

  return (
    <>
      <CommonCardsGrid
        {...props}
        onStatsClick={playerSlug =>
          setCardOpened({
            cardSlug: '',
            playerSlug,
          })
        }
      />
      <Pagination visible />
      <PlayerDrawer
        cardOpened={cardOpened}
        onClose={() => {
          setCardOpened(null);
        }}
      />
    </>
  );
};
